import request from 'services/axios'

interface ISendCodePayload {
    phone_number: string
}
interface ISendConfirmationPayload {
    phone_number: string
    code: string
}
interface ISendTwoFactorPayload {
    phone_number: string
    password: string
    two_factor_token: string
}

export const sendCode = async (payload: ISendCodePayload) => {
    const { data } = await request.post(`/account/otp/request/`, {
        phone_number: '+98' + payload.phone_number.slice(1),
    })
    return data
}
export const sendConfirmation = async (payload: ISendConfirmationPayload) => {
    const { data } = await request.post('/account/otp/login/', {
        phone_number: '+98' + payload.phone_number.slice(1),
        otp: payload.code,
    })
    return data
}
export const sendCodeForPromissory = async (payload: ISendCodePayload) => {
    const { data } = await request.post(`/api/v1/promissory/otp-code/`, {
        phone_number: '+98' + payload.phone_number.slice(1),
    })
    return data
}
export const sendConfirmationForPromissory = async (
    payload: ISendConfirmationPayload
) => {
    const { data } = await request.post(
        '/api/v1/promissory/verify-promissory/',
        {
            phone_number: '+98' + payload.phone_number.slice(1),
            otp: payload.code,
        }
    )
    return data
}
export const sendTwoFactor = async (payload: ISendTwoFactorPayload) => {
    const { data } = await request.post('/api/v1/account/auth/2fa/', {
        phone_number: '+98' + payload.phone_number.slice(1),
        password: payload.password,
        two_factor_token: payload.two_factor_token,
    })
    return data
}
export const getAuthProfile = async () => {
    const { data }: { data: IAuthProfileData } =
        await request.get('/account/profile/')
    return data
}
export const postAuthProfile = async (payload: IAuthprofilePayload) => {
    const { data }: { data: IAuthProfileData } = await request.post(
        '/account/profile/',
        {
            ...payload,
        }
    )
    return data
}
